import React from 'react';

const Cookies = () => {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="section-title bg-white text-center text-primary px-3">Policy</h6>
                    <h1 className="mb-5">Cookie Policy</h1>
                </div>
                <div className="row g-4">
                    <div className="col-lg-12">
                        <h2>Cookie Policy for Fundisha</h2>
                        <p>This is the Cookie Policy for Fundisha, accessible from fundisha.com</p>

                        <h4>What Are Cookies</h4>
                        <p>As is common practice with almost all professional websites this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it and why we sometimes need to store these cookies. We will also share how you can prevent these cookies from being stored however this may downgrade or 'break' certain elements of the sites functionality.</p>

                        <h4>How We Use Cookies</h4>
                        <p>We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.</p>

                        <h4>Disabling Cookies</h4>
                        <p>You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of the this site. Therefore it is recommended that you do not disable cookies.</p>

                        <h4>More Information</h4>
                        <p>Hopefully that has clarified things for you and as was previously mentioned if there is something that you aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with one of the features you use on our site.</p>
                        <p>For more general information on cookies, please read <a href="https://www.cookieconsent.com/what-are-cookies/">"What Are Cookies"</a>.</p>
                        <p>However if you are still looking for more information then you can contact us through one of our preferred contact methods:</p>
                        <ul>
                            <li>Email: support@fundisha.com</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cookies; 